import state from './moduleConfigState.js'
import mutations from './moduleConfigMutations.js'
import actions from './moduleConfigActions.js'
import getters from './moduleConfigGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
